import { API, Auth } from 'aws-amplify';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { RootState, useDispatch, useSelector } from 'src/store';
import { buttonsReset } from 'src/store/modules/buttons';
import { editUserCompany } from 'src/store/modules/client';
import { customlogReset } from 'src/store/modules/customlog';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { trackingReset } from 'src/store/modules/trackings';
import { changeEnter } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import setInitValue from 'src/utils/setInitValue';
import { initTrackingValues } from '../TemplateTracking/FloatingBottomSheetTracking';

const initViewValues = {
  bg: 'color',
  bgOpacity: { bgDimmed: 30 },
  bgImage: {
    background: 'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp'
  },
  bgColor: { background: '#ffffff' },
  radius: { background: 0 },
  deeplink: { background: 'https://www.inappmessage.com/' },
  text: {
    title: 'Safe Laytte',
    sub_title: 'Meet Laytte Special Exhibition for 3 days'
  },
  fontSize: { title: 1.875, sub_title: 1 },
  fontWeight: { title: 500, sub_title: 400 },
  color: { title: '#ffffff', sub_title: '#ffffff' },
  fontFamily: { title: 'Pretendard', sub_title: 'Pretendard' },
  textAlign: {
    title: 'center',
    sub_title: 'left'
  },
  btnText: {
    button: 'Close',
    never_show_button: "Don't show"
  },
  btnFontSize: {
    button: 0.875,
    never_show_button: 0.875
  },
  btnFontWeight: {
    button: 400,
    never_show_button: 400
  },
  btnColor: {
    button: '#000000',
    never_show_button: '#000000'
  },
  btnBgColorR: {
    button: 0,
    never_show_button: 0
  },
  btnBgColorG: {
    button: 0,
    never_show_button: 0
  },
  btnBgColorB: {
    button: 0,
    never_show_button: 0
  },
  btnBgColorA: {
    button: 1,
    never_show_button: 1
  },
  btnFontFamily: {
    button: 'Pretendard',
    never_show_button: 'Pretendard'
  },
  btnAgain: {
    type: 'none',
    never_show_button: "don't show"
  },
  button1: {
    content: [],
    button: [],
    never_show_button: []
  },
  button2: {
    content: [],
    button: [],
    never_show_button: []
  }
};

const FloatingBottomSheet = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.3;

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const btnFontURL = getFontURL(fontFamily?.button);
  const neverShowBtnFontURL = getFontURL(fontFamily?.never_show_button);

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });

    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(trackingReset());
      dispatch(customlogReset());
    };
  }, []);
  const style = `
    @font-face {
			font-family: "title";
			src: url(${titleFontURL});
		}
		@font-face {
			font-family: "subTitle";
			src: url(${subTitleFontURL});
		}
		@font-face {
			font-family: "btn";
			src: url(${btnFontURL});
		}
		@font-face {
			font-family: "neverShowBtn";
			src: url(${neverShowBtnFontURL});
		}
    .root-view {
			width: 100%;
			height: 100%;
			position: relative;
			background: none;
			overflow: hidden;
		}
		.background {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			background: rgba(0, 0, 0, ${displayValue});
		}
		.outer-wrapper {
			position: relative;
			width: 100%;
			height: 100%;
			padding: 0px 20px 30px 20px;
			display: -webkit-flex;
			display: flex;
			-webkit-flex-direction: column;
			flex-direction: column;
			-webkit-justify-content: flex-end;
			justify-content: flex-end;
		}
		.modal-wrapper {
			display: -webkit-flex;
			display: flex;
			width: 100%;
			aspect-ratio: 4 / 3;
			border-radius: ${radius?.background}px;
			padding: 24px 20px 0px 20px;
            background-image: url(${bgImage?.background});
			background-size: cover;
			background-position: center;
			position: relative;
		}

		.contents-box {
			width: 100%;
			display: -webkit-flex;
			display: flex;
			-webkit-flex-direction: column;
			flex-direction: column;
			position: relative;
			z-index: 1;
		}
		.contents-box .title,
		.contents-box .sub-title {
			width: 100%;
			min-height: 48px;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
		}
		.title p {
            width: 100%;
            text-align: ${textAlign?.title};
			color: ${color?.title};
			font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily?.title
          : 'title'
      };
            font-size: ${fontSize?.title}rem;
            font-weight: ${fontWeight?.title};
        }
		.sub-title p {
      width: 100%;
			text-align: ${textAlign?.sub_title};
			color: ${color?.sub_title};
			font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily?.sub_title
          : 'subTitle'
      };
      font-size: ${fontSize?.sub_title}rem;
      line-height: 1.4;
      font-weight: ${fontWeight?.sub_title};
      }
		.btn-wrapper {
			width: 100%;
			height: -webkit-fit-content;
			height: fit-content;
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: space-between;
			justify-content: space-between;
			-webkit-align-items: center;
			align-items: center;
      line-height: 2.5;
		}
		.btn-inner {
			width: 100%;
			font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.never_show_button
        )
          ? btnFontFamily?.never_show_button
          : 'neverShowBtn'
      };
      font-size: ${btnFontSize?.never_show_button}rem;
      font-weight: ${btnFontWeight?.never_show_button};
      color: ${btnColor?.never_show_button};
    }
    .btn-close {
			width: 100%;
			height: 100%;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			justify-content: end;
			-webkit-justify-content: end;
        
            font-family: ${
              [
                'Roboto',
                'Inter',
                'Montserrat',
                'Poppins',
                'Pretendard'
              ].includes(btnFontFamily?.button)
                ? btnFontFamily?.button
                : 'btn'
            };
			font-size: ${btnFontSize?.button}rem;
			
			font-weight: ${btnFontWeight?.button};
			color: ${btnColor?.button};
		}
		

		.btn-close svg {        
			fill: none;
			stroke: ${btnColor?.button};
            margin-left: 0.25rem;
		}
	`;
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root-view">
        <div className="background" />
        <div className="outer-wrapper">
          <div className="btn-wrapper">
            <div className="btn-inner">
              {changeEnter(btnText?.never_show_button)}
            </div>
            <div className="btn-close">
              {changeEnter(btnText?.button)}
              <svg
                width={`${(btnFontSize?.button ?? 0.875) - 0.125}rem`}
                height={`${(btnFontSize?.button ?? 0.875) - 0.125}rem`}
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1 0.5L15 14.5" strokeWidth="2" />
                <path d="M15 0.5L1 14.5" strokeWidth="2" />
              </svg>
            </div>
          </div>
          <div className="modal-wrapper">
            <div className="contents-box">
              <div className="title">
                <p>{changeEnter(text?.title)}</p>
              </div>
              <div className="sub-title">
                <p>{changeEnter(text?.sub_title)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FloatingBottomSheet;
